import React from 'react';
import PropTypes from 'prop-types';
import css from './External.css';
import Icon from 'SF/MaterialIcon';
import StyledButton from '../common/StyledButton';
import { isEmpty } from 'lodash';

const hasProtocol = URL => {
  if ( URL.substr(0, 7).toLowerCase() === "http://" ) return true;
  if ( URL.substr(0, 8).toLowerCase() === "https://" ) return true;
  return false;
}

const External = ({externalURL, setExternalURL, onSubmit}) => {
  const hasError = !hasProtocol(externalURL);
  return (
    <div className={css['container']}>
      <label htmlFor="deep-link-external-link">Paste external link:</label>
      <input
        id="deep-link-external-link"
        className={hasError ? css['error'] : null}
        type="text" 
        value={externalURL}
        onChange={e => setExternalURL(e.target.value)}
        onKeyPress={e => { if ( e.which === 13 || e.charCode === 13 ) onSubmit(); }}
      />
      <StyledButton
        style={{display: isEmpty(externalURL) ? 'none' : 'block'}} 
        className={css['clear-button']} 
        onClick={() => setExternalURL("")}
        aria-label="Clear external URL"
        asLink>
        <Icon icon='close' />
      </StyledButton>
      {hasError && <div><Icon aria-hidden="true" icon="error"/> <span data-testid="external-link-error-message">Link must begin with <b>http://</b> or <b>https://</b></span></div>}
    </div>
  );
}

External.propTypes = {
  externalURL: PropTypes.string.isRequired,
  setExternalURL: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default External;
